var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('nav',{attrs:{"role":"navigation"}},[_c('side-bar-menu'),(_vm.updatePageTitle)?[_c('h2',{staticClass:"pageTitle"},[_vm._v(_vm._s(_vm.updatePageTitle))])]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }